// https://plnkr.co/edit/V39HFDs6yhh7DCvL9a2u?p=preview&preview

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minusSignToParensPipe',
  standalone: false
})
export class MinusSignToParensPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        return value.charAt(0) === '-' ?
           `(${  value.substring(1, value.length)  })` :
           value;
    }
}
